import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import AnnouncementBar from "@/components/AnnouncementBar";
import Footer from "@/components/Footer";
import Header from "@/components/layout/Header";
import About from "@/pages/About";
import Home from "@/pages/Home";
import InvitePage from "@/pages/InvitePage";
import Maintenance from "@/pages/Maintenance";
import Pricing from "@/pages/Pricing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { isMaintenanceMode } from "@/utils/maintenanceMode";

const maintenanceMode = isMaintenanceMode();

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <div className="App min-h-screen bg-background text-foreground">
        <div className="noise-overlay" aria-hidden="true" />
        <BrowserRouter>
          <div className="sticky top-0 z-50 flex flex-col">
            <AnnouncementBar />
            <Header />
          </div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={maintenanceMode ? <Navigate to="/" replace /> : <Pricing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/invite/:code" element={<InvitePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
